import { json2csv_fn } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";
import { getExportName_fn } from '@/utils/common'

export function exportCSV_fn(tableHeader, tableData, startDate, endDate, weekLocaleArray) {
  if (!tableData || tableData.length === 0) { return; }

  const csvData = [];
  const _headerObj = tableHeader.map(item => ({
    label: item.label,
    value: item.prop,
  }));

  tableData.forEach(item => {
    csvData.push({
      ...item,
      searchId: " " + item.searchId.toString()+" ",
    });
  });

  json2csv_fn(csvData, _headerObj,
  // moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.reports.otherTransaction")
  getExportName_fn(
    locale("sideMenu.reports.otherTransaction"),
    '',
    '',
    '',
    `${moment(startDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(startDate).day()]}）~ ${moment(endDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(endDate).day()]}）`,
    res.data.cinemaName,
    moment().format('YYYYMMDDHHmm')
  )
  );
}
